module.exports = __webpack_public_path__ + "fd651e03434828d066f3f945c24649b8.MP3";